import styles from "./Timeline.module.css";
import { useEffect, useState } from "react";
import axios from "axios";
import load from "../../../../../Images/loading.gif";

function Timeline({ app }) {
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            if (app) {
                axios.get(`https://eclipsebots.com/api/timeline/service/${app}`, { withCredentials: true })
                    .then((res) => setEvents(res.data))
                    .catch(() => setEvents([]))
                    .finally(() => setLoading(false));
                clearInterval(interval); // para a verificação depois de carregar
            }
        }, 1000);

        return () => clearInterval(interval); // limpa ao desmontar
    }, [app]);

    if (!app || loading) {
        return (
            <div className={styles.content}>
                <div className={`${styles.size} ${styles.loading}`}>
                    <img src={load} width="20px" height="20px" alt="loading" />
                </div>
            </div>
        );
    }

    return (
        <div className={styles.timeline}>
            <div className={styles.title}>Últimos registros</div>
            {events.length === 0 ? (
                <div className={styles.noData}>
                    Sem eventos ainda. As tuas ações vão aparecer aqui.
                </div>
            ) : (
                <div className={styles.timelines}>
                    {events.map((event, index) => {
                        const isFirst = index === 0;
                        const isLast = index === events.length - 1;

                        return (
                            <div
                                key={event.eventId}
                                className={`
                ${styles.time}
                ${isFirst ? styles.first : ""}
                ${isLast ? styles.last : ""}
            `}
                            >
                                {event.serviceImage && (
                                    <div className={styles.image}>
                                        <img src={event.serviceImage} alt="Imagem da App" />
                                    </div>
                                )}
                                <div className={`${styles.emoji} ${styles.imagem}`}>
                                    {getEmoji(event.type)}
                                </div>
                                <div className={`${styles.name} ${styles.imagem}`}>
                                    <strong>{event.title}</strong> {event.description}.
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    )
}

const getEmoji = (type) => {
    switch (type) {
        case "info": return "ℹ️";
        case "warning": return "⚠️";
        case "error": return "🔴";
        case "success": return "🟢";
        case "custom": return "🛠️";
        default: return "🔔";
    }
};

export default Timeline;